import React from 'react';

import { Outlet } from 'react-router-dom';

const InventoryStoreContent = () => {
  return <Outlet />;
};

export default InventoryStoreContent;
